import React from "react";
import { HStack, Icon, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";

type ClientProfileTypeProps = {
  accent: string;
  icon: IconType;
  label: string;
};

export const ClientProfileTypeMarker: React.FC<ClientProfileTypeProps> = ({
  accent,
  icon,
  label,
}) => (
  <HStack
    spacing="6px"
    align="center"
    color="gray.500"
    fontSize="11px"
    letterSpacing="0.06em"
    textTransform="uppercase"
  >
    <Icon as={icon} color={accent} boxSize="11px" />
    <Text as="span" fontWeight="semibold">
      {label}
    </Text>
  </HStack>
);

type SectionEyebrowProps = {
  accent?: string;
  icon: IconType;
  label: string;
};

export const SectionEyebrow: React.FC<SectionEyebrowProps> = ({
  accent = "#6B7280",
  icon,
  label,
}) => (
  <HStack
    spacing="8px"
    align="center"
    color={accent}
    fontSize="11px"
    letterSpacing="0.12em"
    textTransform="uppercase"
    fontWeight="bold"
    mb="6px"
  >
    <Icon as={icon} boxSize="13px" />
    <Text as="span">{label}</Text>
  </HStack>
);

type InfoLineProps = {
  icon: IconType;
  children: React.ReactNode;
  muted?: boolean;
};

export const InfoLine: React.FC<InfoLineProps> = ({ icon, children, muted = true }) => (
  <HStack spacing="10px" align="center">
    <Icon as={icon} boxSize="14px" color={muted ? "gray.400" : "gray.700"} />
    <Text fontSize="sm" color={muted ? "gray.700" : "gray.900"}>
      {children}
    </Text>
  </HStack>
);
